let service = function (
	$q,
	_
) {
	"ngInject";

	var service = this;

	this.options = function(definitions) {
		var options = definitions.filter(function(definition) {
			return definition.on;
		})
		.map((option) => option.products)
		.reduce(function(a,b) {
			return _.intersection(a,b);
		});

		return $q.resolve(options);
	};

	this.interface = function(definitions, allUids) {
		definitions.forEach((definition) => {
			definition.count = _.intersection(definition.products, allUids).length;
			definition.enabled = definition.count > 3;
		});
	};
};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/definition.service.js